import { useForm } from 'react-hook-form';
import { useAppDispatch, useAppSelector } from 'src/reducers';
import Modal from '../../../atoms/modal/modal';
import Button from '../../../atoms/button/button';
import { closeModal } from '../../../../reducers/modal.reducer';
import { Form, FormError, FormItem, FormRow } from 'src/components/atoms/form';
import Label from 'src/components/atoms/label/label';
import Spinner from '../../../atoms/spinner/spinner';
import { validationSchema } from '../../../../utils/validation-utils';
import { CommissionsSearch } from '../../../../models/commission.model';
import { updateCommissionName } from '../../../../reducers/commissions.reducer';

type Props = {
  commission: CommissionsSearch;
};

export const EditCommissionNameModal = (props: Props) => {
  const { commission } = props;
  const dispatch = useAppDispatch();
  const { loading } = useAppSelector(state => state.commissions);

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm({
    mode: 'onChange',
    defaultValues: { newName: commission.name ?? '' },
  });

  const onSubmit = (data: { newName: string }) => {
    dispatch(updateCommissionName({ commissionId: commission.id, newName: data.newName }));
  };

  return (
    <>
      <Modal.Header />
      <Modal.Body>
        <Form>
          <FormRow>
            <FormItem>
              <Label>Nome</Label>
              <input
                type="text"
                placeholder="Inserisci il nome della commessa"
                autoComplete="off"
                className={`form-control ${errors.newName ? 'is-invalid' : ''}`}
                {...register('newName', validationSchema.required)}
              />
              <FormError error={errors?.newName} validation={validationSchema.required} />
            </FormItem>
          </FormRow>
          <FormRow col="2">
            <FormItem>
              <Button onClick={() => dispatch(closeModal())} size="sm" rounded="rounded-sm" color="light-grey" mode="outline" fullWidth>
                Annulla
              </Button>
            </FormItem>
            <FormItem>
              <Button
                type="submit"
                size="sm"
                rounded="rounded-sm"
                color="black"
                mode="solid"
                fullWidth
                disabled={!isValid || loading}
                onClick={handleSubmit(onSubmit)}
              >
                {loading ? <Spinner color="white" /> : 'Salva'}
              </Button>
            </FormItem>
          </FormRow>
        </Form>
      </Modal.Body>
    </>
  );
};
